//auth
export const LOGIN = "/api/auth/login";
export const REGISTER = "/api/auth/register";
export const REFRESH_TOKEN = "/api/auth/refresh-token";
export const FORGOT_PASSWORD = "/api/auth/forgot-password";
export const OTP_VERIFICATION = "/api/auth/otp-verify";
export const CONFIRM_PASSWORD = "/api/auth/reset-password";
export const INVITATION = "/api/auth/invitation";
export const CONFIRM_INVITATION = "/api/auth/confirm-invitation";
export const SET_PASSWORD = "/api/auth/join";
export const GOOGLE_LOGIN = "/api/auth/verify-google";

//Projects
export const PROJECT_LIST = "/api/projects";
export const CREATE_PROJECT = "/api/projects";
export const PROJECT_KEY = "/api/projects/key";
export const PROJECT_NAME = "/api/projects/validate";
export const DUE_DATE = "/api/projects/due-date";
export const DUE_DATE_DETAILS = "api/projects/due-date/details";
export const SEND_OTP = "/api/auth/send-otp";
export const STARRED_PROJECTS = "/api/projects/star";
export const GET_ALL_LABELS = "/api/labels"
export const PROJECT_COMPONENTS = "/api/components";
export const PROJECT_USERS = "/api/user-projects/projects";


//Users
export const USERS = "/api/users";

//Assign Members
export const ASSIGN_PROJECT_MEMBERS = "/api/user-projects/assign";
export const REMOVE_PROJECT_MEMBERS = "/api/user-projects/remove-user";
export const UPDATE_PROJECT_MEMBER_ROLE = "/api/user-projects";
export const ALL_MEMBERS = "/api/projects/members";

//Issues
export const CREATE_ISSUES = "/api/issues";
export const ISSUE_DATA = "/api/issues";
export const EDIT_ISSUE = "/api/issues";
export const DELETE_ISSUE = "/api/issues";
export const LINKED = "/api/issues/linked";
export const EXPORT_ISSUE = "/api/issues";
export const FLAG_ISSUE = "/api/issues";
export const GET_PROJECT_EPICS = "/api/issues/epic";
export const GET_ALL_STAGE_ISSUES = "/api/issues/sprint-started";

//Active sprints
export const ACTIVE_SPRINT_STAGES = "/api/stages";
export const GET_ALL_ACTIVE_SPRINT_STAGES = "/api/stages/project";
export const DRAG_ISSUES_STAGES = "/api/issues/stages";
export const ISSUES_SEQUENCE = "/api/issues/sequence";
export const PROJECT_FILTER_DETAILS = "/api/issues/filter-details";
export const UPDATE_STAGE ="/api/issues/status-update"
export const UPDATE_STAGE_STATUS = "/api/stages";


//profile
export const UPLOAD_PROFILE = "/api/users/upload-profile";
export const USER_PROFILE = "/api/users";

//Sprints
export const SPRINT_LIST = "/api/sprints/project";
export const CREATE_SPRINT = "/api/sprints";
export const SPRINT_DATA = "/api/sprints";
export const DELETE_SPRINT_DATA = "/api/sprints";
export const EDIT_SPRINT_DATA = "/api/sprints";
export const SPRINT_BACKLOG = "/api/issues/product-backlog";

//Worklog
export const ADD_WORKLOGS = "/api/issue-time-log/"
// export const GET_WORKLOGS = "/api/comments/issue";
export const EDIT_WORKLOGS = "/api/comments";

//Comments
export const ADD_COMMENTS = "/api/comments";
export const GET_COMMENTS = "/api/comments/issue";
export const EDIT_COMMENTS = "/api/comments";

//History
export const GET_HISTORY = "/api/issueHistory";

//all
export const GET_ALL = "/api/issues";

//roles
export const ROLES = "/api/roles";
export const PROJECT_ROLES = "/api/roles/project-scope";
export const APPLICATION_ROLES = "/api/roles/application-scope";
export const USER_LIST = "/api/users/all";

//icons
export const DEFAULT_ICONS = "/api/projects/default-icons";

//teams
export const GET_TEAMS = "/api/teams";
export const CREATE_TEAMS = "/api/teams";

//share issues
export const SHARE_ISSUES = "api/issues/share";

// view all issues
export const VIEW_ALL_ISSUES = "api/issues/filter";
export const GET_FILTER_PROJECTS = "api/projects/users";
export const VIEW_ALL_STASTUS = "api/stages";
export const GET_FILTER_ASSIGNEE = "api/users/project";
export const GET_FILTER_SPRINT = "api/sprints";
export const GET_ASSIGNEE_OR_REPORTERS = " updated the endpoint";

export const CREATE_PROJECTS = "/projects/create-projects";

//Release
export const RELEASES = "/api/release";
export const CREATE_RELEASE = "/api/release";
export const ADD_ISSUES_TO_RELEASE = "/api/release/issues";

// ErrorLog
export const ERRORLOG = "/api/error-logs";

// support Customer
// export const GET_SUPPORT_CUSTOMERS = "/api/projects/{projectId}/customers"
export const CUSTOMER = "/api/customer";
export const INVITE_CUSTOMER = "/api/customer/invite";
export const SET_CUSTOMER_PASSWORD = "/api/customer/join";
export const CUSTOMER_COMMENT = "/api/customer/request/comment";
